var steps = document.querySelectorAll("[data-step-letter]");
var alphabet =
  steps.length > 0
    ? Array.from(steps).map(function (step) {
        return step.getAttribute("data-step-letter");
      })
    : [];
class ProductQuiz extends HTMLElement {
  constructor() {
    super();
    this.params = new URLSearchParams(window.location.search);
    this.options = {};
    this.combination = "";
    this.stepIndex = 1;
    this.dynamicContent = document.querySelectorAll('[data-results-update]')
    let _this = this;
    alphabet.forEach(function (letter) {
      _this.options[letter] = "";
    });
    this.attachListeners();
    this.checkParams();
  }
  checkParams() {
    let _this = this;
    _this.stepIndex = 1;
    _this.params.forEach(function (i, j) {
      if (alphabet.indexOf(j) > -1 && i != "") {
        _this.stepIndex = _this.stepIndex + 1;
        _this
          .querySelector('[data-option="' + j + '"][value="' + i + '"]')
          .click();
      }
    });
    _this.updateCombination();
    _this.updateVisibility();
    this.updatePage(_this.stepIndex);
  }

  updatePage(index) {
    if (index) this.stepIndex = index;
    console.log("update page", this.stepIndex);
    document.querySelectorAll(".form-group").forEach(function (step) {
      step.style.display = "none";
    });
    document.querySelector(
      '.form-group[data-index="' + this.stepIndex + '"]'
    ).style.display = "block";
    if( this.stepIndex > steps.length ) {
      this.showSummaryContent()
    } else {
      this.showQuizContent()
    }
  }

  showSummaryContent() {
    this.dynamicContent.forEach(function (item) {
      let content = item.getAttribute('data-results-value')
      item.innerHTML = content
    });
  }
  showQuizContent() {
    this.dynamicContent.forEach(function (item) {
      let content = item.getAttribute('data-quiz-value')
      item.innerHTML = content
    });
  }

  attachListeners() {
    let _this = this;

    window.addEventListener("popstate", function (e) {
      e.preventDefault();
      if (e.state !== null) {
        console.log("e !== null");
        setTimeout(function () {
          _this.params = new URLSearchParams(window.location.search);
          let lastLetter = alphabet[_this.stepIndex - 2];
          _this.params.delete(lastLetter);
          window.history.pushState(
            {},
            null,
            window.location.origin +
              window.location.pathname +
              "?" +
              _this.params.toString()
          );
          _this.checkParams();
        }, 0);
      }
    });

    this.querySelectorAll("input").forEach(function (input) {
      input.addEventListener("change", function (e) {
        _this.updateOption(input.getAttribute("data-option"), input.value);
      });
    });
    this.querySelectorAll(".form-group").forEach(function (formGroup) {
      formGroup.querySelector("button").addEventListener("click", function (e) {
        e.preventDefault();
        if (formGroup.querySelector("input:checked")) {
          _this.updateOption(
            formGroup.getAttribute("data-step-letter"),
            formGroup.querySelector("input:checked").value
          );
          _this.updateCombination();
          _this.updateVisibility();
          _this.stepIndex = _this.stepIndex + 1;
          _this.updatePage();
        }
        return false;
      });
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    console.log(`Attribute ${name} has changed.`);
  }
  updateOption(letter, value) {
    if (
      document.querySelector(
        '[data-step-letter="' + letter + '"] .btn[disabled]'
      )
    ) {
      document
        .querySelector('[data-step-letter="' + letter + '"] .btn[disabled]')
        .removeAttribute("disabled");
    }
    this.options[letter] = value;
    this.params.set(letter, value);
  }
  updateCombination() {
    let options = this.options;
    let selectedOptions = "";
    let queryString = "";
    Object.keys(options).forEach(function (key) {
      if (options[key] && options[key] != "") {
        selectedOptions += key + options[key];
        queryString += key + "=" + options[key] + "&";
      }
    });
    window.history.pushState(
      {},
      null,
      window.location.origin +
        window.location.pathname +
        "?" +
        queryString.slice(0, -1)
    );
    this.combination = selectedOptions;
  }
  updateVisibility() {
    let _this = this;
    document.querySelectorAll("[data-show-if]").forEach(function (item) {
      let showIf = item.getAttribute("data-show-if").split(",");
      let showEl = false;
      showIf.forEach(function (showIfEl) {
        if (_this.combination.indexOf(showIfEl) > -1) showEl = true;
      });
      item.style.display = showEl ? "" : "none";
    });
  }
}
customElements.define("product-quiz", ProductQuiz);
